import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostListener,
  Input,
  ViewEncapsulation
} from '@angular/core';
import {SearchTableCellService} from '../search-table-cell.service';
import {debounceTime, map, switchMap, tap} from 'rxjs/operators';
import {Publication} from 'asax-common';
import {combineLatest, Subject} from 'rxjs';
import {ColumnMode, SortType} from '@almaobservatory/ngx-datatable';

const timeoutTimer = 300;

@Component({
  selector: 'asax-result-table-search-table-cell-publications',
  templateUrl: './cell-publications.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [`
    .ngx-datatable.publications-datatable.fixed-row .datatable-scroll .datatable-body-row .datatable-body-cell {
      white-space: normal !important;
    }
  `],
  encapsulation: ViewEncapsulation.None
})
export class CellPublicationsComponent {
  readonly pageSizeLimit = 10;
  readonly rowHeight = 100;
  readonly headerHeight = 40;

  @Input() projectCode: string;
  @Input() numberPublications: number;

  rows: Publication[];
  SortType = SortType;

  totalRows = 0;

  tableScrollOffset = 0;

  sortElasticProp: any = [{bibCode: {order: 'asc'}}];
  sortNgxDataTableProp: any = [{prop: 'bibCode', dir: 'asc'}];

  fetchPublicationsSubject = new Subject();
  mouseEnterSubject = new Subject();

  ColumnMode = ColumnMode;

  private timeout: NodeJS.Timeout;

  constructor(private readonly ref: ChangeDetectorRef,
              private readonly searchTableCellService: SearchTableCellService) {
    combineLatest([
      this.fetchPublicationsSubject.asObservable(),
      this.mouseEnterSubject.asObservable()
    ]).pipe(
      debounceTime(500),
      map(() => ({
        from: this.tableScrollOffset,
        size: this.pageSizeLimit,
        source: ['firstAuthor', 'journal', 'bibCode', 'publicationYear', 'title'],
        sort: this.sortElasticProp
      })),
      switchMap(searchTablePage => this.searchTableCellService.fetchPublications(this.projectCode, searchTablePage)),
      tap(searchResultTablePage => this.totalRows = searchResultTablePage.totalRows),
      tap(searchResultTablePage => {
        const rows = new Array(searchResultTablePage.from);
        rows.splice(searchResultTablePage.from, 0, ...searchResultTablePage.rows);
        this.rows = rows;
      }),
      tap(() => this.ref.markForCheck())
    ).subscribe();
  }

  onPage($event: any): void {
    const from = ($event.offset * $event.pageSize) - Math.floor(this.pageSizeLimit / 2);
    this.tableScrollOffset = (from < 0) ? 0 : from;
    this.fetchPublicationsSubject.next(undefined);
  }

  onSort({sorts}: any): void {
    const {prop, dir} = sorts[0];
    this.sortElasticProp = {[prop]: {order: dir}};
    this.fetchPublicationsSubject.next(undefined);
  }

  @HostListener('mouseenter')
  private onMouseEnter(): void {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => this.mouseEnterSubject.next(undefined), timeoutTimer);
  }

  @HostListener('mouseleave')
  private onMouseLeave(): void {
    clearTimeout(this.timeout);
  }
}
